import React, { Component } from "react";
import { Link } from "react-router-dom";
import history from "../../history";
import { Col, Form, Row } from "reactstrap";
import Icon from "react-icons-kit";
import "../../assets/scss/components/login-register/index.scss";
import { ic_remove_red_eye } from "react-icons-kit/md/ic_remove_red_eye";
import { eyeBlocked } from "react-icons-kit/icomoon/eyeBlocked";
import { ic_lock } from "react-icons-kit/md/ic_lock";
import InputText from "../InputText";
import { ic_email } from "react-icons-kit/md/ic_email";
import CustomBtn from "../CustomButton";
import Config from "../../utils/config";
import Image from "../ImageComponent";
import Loader from "../Loader";

import get from "lodash/get";

const _ = { get };

class OTPVarification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      otp: "",
      ShowPassword: false,
      password: "",
    };
  }

  componentDidMount() {
    if (this.props.username === "") {
      history.push("/auth/forget-password");
    }
  }

  handleToggleIcon = () => {
    let state = { ...this.state };
    state.ShowPassword = !state.ShowPassword;
    this.setState({ ...state });
  };

  handleChange = (e) => {
    e.preventDefault();
    let state = this.state;
    state[e.target.name] = e.target.value.trim();
    this.setState({ ...state });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    let state = this.state;
    let data = {
      otp: state.otp,
      password: state.password,
    };
    this.props.handleSetNewPassword(data);
  };

  render() {
    let { elements } = this.props;
    return (
      <React.Fragment>
        {this.props.setNewPasswordStatus !== false ? <Loader /> : null}
        <Row className=" no-gutters h-100">
          <Col
            sm="12"
            md="12"
            lg="12"
            xl="6"
            className="user-auth-wrapper h-100"
            style={{
              backgroundImage: `url(${Config.imageBaseUrl}/EU0001/node/assets/dashboard/riders-portal/login-banner.webp)`,
            }}
          ></Col>
          <Col sm="12" md="12" lg="12" xl="6" className="h-100 login-wrapper">
            <div className="light-overlay">
              <div className="user-auth-container">
                <div className="logo">
                  <Image
                    tag="false"
                    src={`${Config.imageBaseUrl}/content/dam/re-platform-images/logo.svg`}
                    alt="Royal Enfield"
                  />
                </div>
                <div className="app-login-register-container">
                  <Form onSubmit={this.handleSubmit} className="w-100">
                    <div className="p-2 p-lg-0">
                      <div className="position-relative">
                        <Icon
                          size={22}
                          className="inputIcon LeftIcon"
                          icon={ic_email}
                        />
                        <InputText
                          inputType={"text"}
                          inputName={"otp"}
                          InputClass={"mt-3 mt-lg-5 mb-4 inputText"}
                          inputPlaceholder={_.get(
                            elements,
                            "otpVerifyElement.otpPlaceholder",
                            "Enter OTP"
                          )}
                          customOnChange={(e) => this.handleChange(e)}
                          customIcon={ic_email}
                          IconClass={"inputIcon LeftIcon"}
                          iconSize={22}
                        />
                      </div>
                      <div className="position-relative">
                        <Icon
                          size={22}
                          className="inputIcon LeftIcon"
                          icon={ic_lock}
                        />
                        <InputText
                          inputType={
                            this.state.ShowPassword ? "password" : "text"
                          }
                          inputName={"password"}
                          InputClass={"mt-2 mt-lg-5 mb-4 inputText"}
                          inputPlaceholder={_.get(
                            elements,
                            "otpVerifyElement.sendOTPButtonElement",
                            "Enter New Password"
                          )}
                          customOnChange={(e) => this.handleChange(e)}
                          customIcon={ic_lock}
                          IconClass={"inputIcon LeftIcon"}
                          rightIcon={
                            this.state.ShowPassword
                              ? eyeBlocked
                              : ic_remove_red_eye
                          }
                          iconSize={22}
                        />
                        <Icon
                          size={18}
                          className="RightIcon inputIcon"
                          onClick={this.handleToggleIcon}
                          icon={
                            this.state.ShowPassword
                              ? eyeBlocked
                              : ic_remove_red_eye
                          }
                        />
                      </div>
                      <div className="bottom-sec">
                        <div className="d-flex align-items-center justify-content-center flex-column position-relative">
                          <CustomBtn
                            customType={"submit"}
                            name={_.get(
                              elements,
                              "otpVerifyElement.verifyButton",
                              "Verify"
                            )}
                            customClass={"btn-outline-dark mb-4 btnthemeColor"}
                            iconSize={30}
                          />
                          <Link to="/auth/forget-password" className="link">
                            <span className="bg-white position-relative px-2">
                              {_.get(
                                elements,
                                "otpVerifyElement.backButtonElement",
                                "Back"
                              )}
                            </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export default OTPVarification;
